"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for user management
 * Handles current user information and authentication
 */
class MeRoutes extends base_1.ApiBase {
    /**
     * Get current authenticated user information
     * @returns Promise resolving to current user data
     * @throws Error if the API request fails or user is not authenticated
     */
    async getCurrentUser() {
        return this.apiGet(constants_1.ROUTES.ME);
    }
    /**
     * Get current user's Twitch bot configuration
     * @returns Promise resolving to user's Twitch bot config
     * @throws Error if the API request fails or user is not authenticated
     */
    async getTwitchBotConfig() {
        return this.apiGet(`${constants_1.ROUTES.ME}/twitch`);
    }
}
exports.MeRoutes = MeRoutes;
//# sourceMappingURL=me.js.map